import React from 'react';
import PropTypes from 'prop-types';
import { compose, withHandlers } from 'recompose';
import { Field } from 'redux-form';

import { Button } from 'components/core/Button';
import { Form, FormItem, TextArea, TextInput } from 'components/core/Form';
import { IconText } from 'components/core/IconText';
import { RadioInput, RadioGroup } from 'components/core/RadioInput';
import { Link } from 'components/core/Link';
import { StarInput } from 'components/form';
import { Text } from 'components/core/Text';
import { withFormHandler } from 'decorators';

import validate from './ReviewFormValidation';
import './ReviewForm.scss';


export const enhance = compose(
	withHandlers({
		onSubmit: (props) => (formData) => props.onSubmit({
			...formData,
			facilityId: props.facilityId,
			confirmationCode: (
				!props.requireConfirmationCode ? 'CONFIRMATION_CODE_NOT_REQUIRED' : formData.confirmationCode
			)
		})
	}),
	withFormHandler({
		form: 'facility-review',
		validate
	}),
);


export function ReviewForm({
	error, confirmationCode, handleSubmit, invalid, requireConfirmationCode, submitting
}) {
	return (
		<div className="review-form">
			<Form
				onSubmit={handleSubmit}
				invalid={invalid}
				successLabel="success-review-form"
				failureLabel="fail-review-form"
				id="review-form"
			>
				<div className="ratings">
					<FormItem>
						<Field
							name="rating"
							id="rating"
							classsName="primary"
							label="Overall rating (1-5 stars)"
							halfStep
							size="large"
							component={StarInput}
						/>
					</FormItem>
					<FormItem>
						<Field
							name="ratingPrice"
							id="ratingPrice"
							label="Pricing"
							component={StarInput}
						/>
					</FormItem>
					<FormItem>
						<Field
							name="ratingCleanliness"
							id="ratingCleanliness"
							label="Cleanliness"
							component={StarInput}
						/>
					</FormItem>
					<FormItem>
						<Field
							name="ratingService"
							label="Customer service"
							component={StarInput}
						/>
					</FormItem>
				</div>
				<FormItem>
					<Field
						name="ratingRecommended"
						label="Would you recommend this facility to a friend?"
						component={RadioGroup}
					>
						<RadioInput
							component={RadioInput}
							label="Yes"
							value="1"
						/>
						<RadioInput
							label="No"
							value="0"
						/>
					</Field>
				</FormItem>
				<FormItem>
					<Field
						name="title"
						label="One-line summary"
						helpText="Character limit: 75 (Minimum 5)"
						component={TextInput}
					/>
				</FormItem>
				<FormItem>
					<Field
						name="message"
						label="Review"
						helpText="Character limit: 2000 (Minimum 30)"
						component={TextArea}
					/>
				</FormItem>
				<FormItem>
					<Field
						name="nickname"
						label="Your name"
						component={TextInput}
					/>
				</FormItem>
				<FormItem>
					<Field
						name="email"
						label="Your email address"
						type="email"
						component={TextInput}
					/>
				</FormItem>
				{requireConfirmationCode &&
					<FormItem>
						<Field
							name="confirmationCode"
							label="Confirmation code"
							readOnly={confirmationCode ? 'readOnly' : null}
							component={TextInput}
						/>
					</FormItem>
				}
				<div className="tos-text">
					<Text size="small">
						By submitting this review, I acknowledge and agree
						to the
						{' '}
						<Link
							href="/legal/reviewstoc.html"
							target="_blank"
							rel="noopener noreferrer"
						>
							Terms and Conditions.
						</Link>
					</Text>
				</div>
				{!!error &&
					<IconText type="alert">
						{error}
					</IconText>
				}
				<div className="form-submit">
					<Button
						type="submit"
						disabled={submitting}
						className="submit-button"
					>
						Submit review
					</Button>
				</div>
			</Form>
		</div>
	);
}

ReviewForm.propTypes = {
	error: PropTypes.string,
	confirmationCode: PropTypes.string,
	handleSubmit: PropTypes.func,
	invalid: PropTypes.bool,
	submitting: PropTypes.bool,
	requireConfirmationCode: PropTypes.bool
};

ReviewForm.defaultProps = {
	requireConfirmationCode: true
};


export default enhance(ReviewForm);
